import { WebsiteSectionUrl } from "@/components/constants";

/**
 * Определяет, нужно ли запускать опрос активных сессий на текущей странице
 */
export const shouldRunSessionPolling = (
  pathname: string,
  isUserLoggedIn: boolean,
): boolean => {
  const excludedPaths = [
    WebsiteSectionUrl.Chat,
    WebsiteSectionUrl.TextChat,
    WebsiteSectionUrl.Appointment,
    WebsiteSectionUrl.FixMediaAccess,
  ];

  const normalizedPath = pathname.replace(/^\/+/, "") as WebsiteSectionUrl;
  const isExcludedPath = excludedPaths.includes(normalizedPath);

  return isUserLoggedIn && !isExcludedPath;
};
